import { Component } from '@angular/core';

@Component({
    selector: 'op-special-service',
    templateUrl: './special-service.component.html'
})
export class SpecialServiceComponent {

}
